<template>
  <ModalBuyOrder v-if="toggleModal === 'ModalBuyOrder'" :orderId="orderId" @cancelModal="toggleModal = ''" />
  
  <div class="bg-gray-900 px-4 py-2">
    <div class="mb-2">
      <label for="type" class="block text-indigo-100 mb-1 font-semibold">เลือกประเภท:</label>
      <select v-model="selectedType" class="p-2 w-full rounded bg-gray-800 text-white border border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600">
        <option v-for="(type, index) in types" :key="index" :value="type">{{ type.name }}</option>
      </select>
    </div>

    <!-- Item Selection -->
    <div v-if="items.length > 0" class="mb-2">
      <label for="item" class="block text-indigo-100 mb-1 font-semibold">เลือกไอเทม:</label>
      <select v-model="selectedItem" class="p-2 w-full rounded bg-gray-800 text-white border border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600">
        <option v-for="(item, index) in items" :key="index" :value="item">{{ item }}</option>
      </select>
    </div>
  </div>

  <div class="p-1 pb-16 mb-auto h-full text-white overflow-auto" id="style-1">
    <!-- Orders Display -->
    <div class="flex-grow overflow-auto text-white custom-scrollbar">
      <div v-if="orders.length > 0" class="space-y-1">
        <div v-for="(order, index) in orders" :key="index" @click="handleModalBuyOrder('ModalBuyOrder', order.id)" class="p-2 rounded-lg bg-gray-900 bg-opacity-80 hover:bg-opacity-100 transition duration-300 shadow-lg cursor-pointer">
          <div class="flex justify-between items-center">
            <div class="flex items-center space-x-2">
              <img :src="order.img" class="w-8 h-8 object-cover rounded-full shadow-md">
              <div class="flex items-center space-x-1 border border-gray-500 rounded px-1">
                <div><img src="../../assets/images/star.png" class="w-3"></div>
                <div class="text-sm sm:text-base">{{ order.star }}</div>
              </div>
              <div :class="[order.textColor]" class="font-bold text-sm sm:text-base">{{ order.name }}</div>
            </div>
            <div class="flex items-center bg-indigo-900 text-indigo-100 font-bold px-3 py-2 rounded-full shadow-md">
              <div>{{ order.price }}</div>
              <img src="../../assets/images/coin.png" class="w-5 ml-1">
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center text-gray-400 mt-8">ไม่มีรายการขาย</div>
    </div>

    <!-- Load More Button -->
    <div v-if="hasMore" class="text-center mt-2">
      <button @click="loadMoreOrders" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 w-full rounded text-white font-bold">
        โหลดเพิ่มเติม
      </button>
    </div>
  </div>
</template>

<script>
import { projectFirestore } from '@/firebase/config';
import { ref, onMounted, watch } from 'vue';
import ModalBuyOrder from './ModalBuyOrder.vue';

export default {
  components: { ModalBuyOrder },
  setup() {
    const types = ref([
      { name: 'อาวุธ', value: 'weapon', list: ['ส้อม', 'มีดหั่นผัก','พลั่ว','มีด','อีโต้','ขวาน','ดาบโจรสลัด','ดาบเหล็กกล้า'] },
      { name: 'อาวุธรอง', value: 'offhand', list: ['โล่ชนพื้นเมือง', 'โล่ชนพื้นเมือง+2','โล่ชนพื้นเมือง+3','โล่ชนพื้นเมือง+4','โล่ชนพื้นเมือง+5','โล่ชนพื้นเมือง+6','โล่ชนพื้นเมือง+7','โล่ชนพื้นเมือง+8'] },
      { name: 'หมวก', value: 'head', list: ['หมวกขาด', 'หมวกคนจร','หมวกชาวไร่','หมวกนักเลง','หมวกโจร','หมวกพ่อค้า','หมวกโจรสลัด','หมวกคนรวย'] },
      { name: 'แว่นตา', value: 'glasses', list: ['แว่นตานักเดินทาง', 'แว่นตานักเดินทาง+2','แว่นตานักเดินทาง+3','แว่นตานักเดินทาง+4','แว่นตานักเดินทาง+5','แว่นตานักเดินทาง+6','แว่นตานักเดินทาง+7','แว่นตานักเงดินทาง+8'] },
      { name: 'ปาก', value: 'mouth', list: ['ซิการ์', 'ซิการ์+2','ซิการ์+3','ซิการ์+4','ซิการ์+5','ซิการ์+6','ซิการ์+7','ซิการ์+8'] },
      { name: 'ผ้าพันคอ', value: 'neck', list: ['ผ้าพันคอขาด', 'ผ้าพันคอคนจร','ผ้าพันคอชาวไร่','ผ้าพันคอนักเลง','ผ้าพันคอโจร','ผ้าพันคอพ่อค้า','ผ้าพันคอโจรสลัด','ผ้าพันคอคนรวย'] },
      { name: 'สร้อยคอ', value: 'necklace', list: ['สร้อยคอเขี้ยวหมาป่า', 'สร้อยคอเขี้ยวหมาป่า+2','สร้อยคอเขี้ยวหมาป่า+3','สร้อยคอเขี้ยวหมาป่า+4','สร้อยคอเขี้ยวหมาป่า+5','สร้อยคอเขี้ยวหมาป่า+6','สร้อยคอเขี้ยวหมาป่า+7','สร้อยคอเขี้ยวหมาป่า+8'] },
      { name: 'เสื้อคุม', value: 'cape', list: ['เสื้อคุมขาด', 'เสื้อคุมคนจร','เสื้อคุมชาวไร่','เสื้อคุมนักเลง','เสื้อคุมโจร','เสื้อคุมพ่อค้า','เสื้อคุมโจรสลัด','เสื้อคุมคนรวย'] },
      { name: 'กระเป๋า', value: 'bag', list: ['กระเป๋านักผจญภัย', 'กระเป๋านักผจญภัย+2','กระเป๋านักผจญภัย+3','กระเป๋านักผจญภัย+4','กระเป๋านักผจญภัย+5','กระเป๋านักผจญภัย+6','กระเป๋านักผจญภัย+7','กระเป๋านักผจญภัย+8'] },
      { name: 'เชือก', value: 'lasso', list: ['เชือกนักผจญภัย', 'เชือกนักผจญภัย+2','เชือกนักผจญภัย+3','เชือกนักผจญภัย+4','เชือกนักผจญภัย+5','เชือกนักผจญภัย+6','เชือกนักผจญภัย+7','เชือกนักผจญภัย+8'] },
      { name: 'เกาะ', value: 'armor', list: ['เกาะซองอาวุธ+2','เกาะซองอาวุธ+3','เกาะซองอาวุธ+4','เกาะซองอาวุธ+5','เกาะซองอาวุธ+6','เกาะซองอาวุธ+7','เกาะซองอาวุธ+8'] },
      { name: 'เสื้อ', value: 'body', list: ['เสื้อคุมขาด', 'เสื้อคนจร','เสื้อชาวไร่','เสื้อนักเลง','เสื้อโจร','เสื้อพ่อค้า','เสื้อโจรสลัด','เสื้อคนรวย'] },
      { name: 'เข็มทิศ', value: 'compass', list: ['เข็มทิศที่สูญหาย', 'เข็มทิศที่สูญหาย+2','เข็มทิศที่สูญหาย+3','เข็มทิศที่สูญหาย+4','เข็มทิศที่สูญหาย+5','เข็มทิศที่สูญหาย+6','เข็มทิศที่สูญหาย+7','เข็มทิศที่สูญหาย+8'] },
      { name: 'ปลอกแขน', value: 'armlet', list: ['ปลอกแขนเหล็ก', 'ปลอกแขนเหล็ก+2','ปลอกแขนเหล็ก+3','ปลอกแขนเหล็ก+4','ปลอกแขนเหล็ก+5','ปลอกแขนเหล็ก+6','ปลอกแขนเหล็ก+7','ปลอกแขนเหล็ก+8'] },
      { name: 'แหวน', value: 'ring', list: ['แหวนนักล่า+2','แหวนนักล่า+3','แหวนนักล่า+4','แหวนนักล่า+5','แหวนนักล่า+6','แหวนนักล่า+7','แหวนนักล่า+8'] },
      { name: 'ถุงมือ', value: 'glove', list: ['ถุงมือนักล่า+2','ถุงมือนักล่า+3','ถุงมือนักล่า+4','ถุงมือนักล่า+5','ถุงมือนักล่า+6','ถุงมือนักล่า+7','ถุงมือนักล่า+8'] },
      { name: 'เข็มขัด', value: 'waist', list: ['เข็มขัดนักล่า+2','เข็มขัดนักล่า+3','เข็มขัดนักล่า+4','เข็มขัดนักล่า+5','เข็มขัดนักล่า+6','เข็มขัดนักล่า+7','เข็มขัดนักล่า+8'] },
      { name: 'กางเกง', value: 'bottom', list: ['กางเกงขาด', 'กางเกงคนจร','กางเกงชาวไร่','กางเกงกเลง','กางเกงโจร','กางเกงพ่อค้า','กางเกงโจรสลัด','กางเกงคนรวย'] },
      { name: 'รองเท้า', value: 'foots', list: ['รองเท้าขาด', 'รองเท้าคนจร','รองเท้าชาวไร่','รองเท้านักเลง','รองเท้าโจร','รองเท้าพ่อค้า','รองเท้าโจรสลัด','รองเท้าคนรวย'] },
      { name: 'ตราสัญลักษณ์', value: 'emblem', list: ['ตราสัญลักษณ์วิลเลี่ยม', 'ตราสัญลักษณ์วูดดี้','ตราสัญลักษณ์วิกกี้','ตราสัญลักษณ์เมสัน','ตราสัญลักษณ์มูน','ตราสัญลักษณ์ลูกคัส','ตราสัญลักษณ์เบนจามิน','ตราสัญลักษณ์เจคอบ'] },
      { name: 'เครื่องราง', value: 'amulet', list: ['เครื่องรางชนพื้นเมือง','เครื่องรางชนพื้นเมือง+2','เครื่องรางชนพื้นเมือง+3','เครื่องรางชนพื้นเมือง+4','เครื่องรางชนพื้นเมือง+5','เครื่องรางชนพื้นเมือง+6','เครื่องรางชนพื้นเมือง+7','เครื่องรางชนพื้นเมือง+8'] },
      { name: 'สัตว์เลี้ยง', value: 'pet', list: ['บูลด็อก', 'บอร์เดอร์คอลลี่','เกรทเดน','เยอรมันเชพเพิร์ด','โดเบอร์แมน','พิทบูล','ร็อตไวเลอร์'] },
      { name: 'ม้า', value: 'horse', list: ['ม้าฟรีเซียน', 'ม้าอันดาลูเซีย','ม้าควอเตอร์','ม้าอาหรับ','ม้าธอร์เบรด'] },
      { name: 'ของสะสม', value: 'collection', list: ['กระป๋องขอทาน', 'เศษผ้าเก่า','กระดาษลัง','หีบเพลงเก่า','ช้อน','ระเบิด', 'กระทะกรองทอง','เศษหิน','รถเข็นขนแร่','ชะแลง','หินน้ำตาล','เขี้ยวหมูป่า','ผลไม้','หนังหมูป่า','ลูกตาหมูป่า','ถุงผ้าเก่า', 'ผ้าห่มขาด','ขวดน้ำ','เศษกระดาษ','ของเล่นเก่า','กระดูกสัตว์ป่า','หนังติดเลือด','หินสีดำ','เศษเสื้อ','หางหมาป่า','คบเพลิง', 'เขากวางมูส','เชือก','รูปภาพเก่า','หินล้ำค่า','กระโหลกนักเดินทาง', 'ใบไม้สีหายาก','เขี้ยวสัตว์ป่า','ลากไม้','ขนนกชั้นเลิศ','ตะเกียง', 'กิ่งไม้','สายจูงสัตว์','เข็มขัดบาง','ใบมีด','นาฬิกาทราย','แผนที่ล้ำค่า','เกือกม้า','หมายประกาศจับ','เอกสารลับ','เศษทรายหายาก','ขวดเหล้าเปล่า','เศษซากกระดูก','กระติกน้ำ','แผนที่ขาด','ธนบัตรเก่า','เครื่องลายคราม','ผ้าไหม','สมุดบัญชี','แผนที่รถไฟ','แผนที่สมบัติ','ถ้วยเงิน','กาน้ำ','ธงโจรสลัด','ผ้าโพกหัว','แจกันโจรสลัด','จานแตก','แกวน้ำโจรสลัด','แผ่นไม้','ตะปู','นาฬิกาสร้อยคอ','แหวนอัญมนี','ภาพวาดยุโรป','กำไลทองคำ','หนังสือพิมพ์'] },
      { name: 'แผนที่', value: 'map', list: ['แผนที่ป่าซานฮวน'] },
      
    ]);

    const selectedType = ref(null);
    const items = ref([]);
    const selectedItem = ref('');
    const orders = ref([]);
    const lastVisibleDoc = ref(null);
    const hasMore = ref(true);
    const limit = 20;

    // Modal state
    const toggleModal = ref('');
    const orderId = ref('');

    // Watch for changes in selectedType
    watch(selectedType, (newType) => {
      if (newType) {
        items.value = newType.list; // Update the list of items
        selectedItem.value = ''; // Reset selected item
        orders.value = []; // Clear previous orders
        lastVisibleDoc.value = null; // Reset last visible document
        fetchOrders(); // Fetch new orders based on the selected type
      }
    });

    // Watch for changes in selectedItem
    watch(selectedItem, (newItem) => {
      if (newItem) {
        orders.value = []; // Clear previous orders
        lastVisibleDoc.value = null; // Reset last visible document
        fetchOrders(); // Fetch new orders based on the selected item
      }
    });

    const fetchOrders = () => {
      let query = projectFirestore.collection('orders').limit(limit);

      if (selectedType.value) {
        query = query.where('type', '==', selectedType.value.value);
        if (selectedItem.value) {
          query = query.where('name', '==', selectedItem.value);
        }
        query = query.orderBy('price', 'asc');
      } else {
        query = query.orderBy('createdAt', 'desc');
      }

      if (lastVisibleDoc.value) {
        query = query.startAfter(lastVisibleDoc.value);
      }

      query.get().then(snapshot => {
        if (snapshot.empty) {
          hasMore.value = false;
        } else {
          snapshot.forEach(orderDoc => {
            orders.value.push(orderDoc.data());
          });
          lastVisibleDoc.value = snapshot.docs[snapshot.docs.length - 1];
        }
      });
    };

    const loadMoreOrders = () => {
      if (hasMore.value) {
        fetchOrders();
      }
    };

    const handleModalBuyOrder = (modal, id) => {
      toggleModal.value = modal;
      orderId.value = id;
    };

    onMounted(() => {
      fetchOrders();
    });

    return {
      handleModalBuyOrder,
      toggleModal,
      orderId,
      types,
      selectedType,
      items,
      selectedItem,
      orders,
      loadMoreOrders,
      hasMore,
    };
  },
};
</script>

<style scoped>
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #4a5568 #2d3748;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #4a5568;
  border-radius: 10px;
}
</style>
